import type { ReactNode } from 'react';
import { AlertCircle, Inbox, RotateCw } from 'lucide-react';

export function Loading({ text = '内容加载中…' }: { text?: string }) {
  return (
    <div className="state-box" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span className="state-desc">{text}</span>
    </div>
  );
}

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message = '内容暂时无法加载，请稍后重试。', onRetry }: ErrorStateProps) {
  return (
    <div className="state-box" role="alert">
      <AlertCircle size={30} className="state-icon" aria-hidden="true" />
      <span className="state-title">加载失败</span>
      <span className="state-desc">{message}</span>
      {onRetry && (
        <button type="button" className="btn btn-outline btn-sm" onClick={onRetry}>
          <RotateCw size={14} aria-hidden="true" />
          重新加载
        </button>
      )}
    </div>
  );
}

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="state-box">
      <Inbox size={30} className="state-icon" aria-hidden="true" />
      <span className="state-title">{title}</span>
      {description && <span className="state-desc">{description}</span>}
      {action}
    </div>
  );
}
